import { useId } from "react";
import { FDWAntragsteller } from "restfd2";
import { useQuestionizerStore } from "../types/state.ts";
import Select from "./select.tsx";

// export default function InputAntragsteller (props: {id: number, label: string}){
//   const antragsteller = useQuestionizerStore((state) => state.antragsteller);
//   const setAntragsteller = useQuestionizerStore((state) => state.setAntragsteller);
//   const setValidation = useQuestionizerStore((state) => state.setValidation);
  
//   return <div>
//     <label>{props.label}</label>
//     <input type="text" value={""} onChange={()=>{
//       setValidation(props.id, {message:"", valid: true});
//     }}/>
//   </div>
// }

export default function InputAntragstellerSelect (props: {id: number, label: string, onBlur?: ()=>void}){
  const id = useId()

  const antragsteller = useQuestionizerStore((state) => state.antragsteller);
  const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
  const setantragsteller_detail = useQuestionizerStore((state) => state.setantragsteller_detail);
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);

  const label = useQuestionizerStore((state) => state.L('input-antragsteller-select'));

 if (antragsteller === undefined || antragsteller.length < 2){return <div></div>}
  return <div  className={"input-antragsteller-select input-"+props.id}>
    <label id={id} className={"input-antragsteller-select__label"}>{label}</label>
    <Select<number> 
        id={props.id.toString()}
        label={props.label} 
        value={antragsteller_detail || -1} 
        onBlur={props.onBlur}
        onChange={(value) => {
         setantragsteller_detail(value);
         updateValidation();
        }}>
        {antragsteller_detail === undefined && <option role="option" key={"default"} value={-1}>{props.label}</option>}
        {antragsteller.map((antragsteller)=><option role="option" value={antragsteller} key={antragsteller}>{FDWAntragsteller[antragsteller]}</option>)}
      </Select>
  </div>
  
}
